import Dealer from "./Dealer";
import TargetMatrics from "./TargetMatrics";
import TargetUsageReport from "./TargetUsageReport";
import TargetFeedReport from "./TargetFeedReport";
import TargetBroadcastEmailReport from "./TargetBroadcastEmailReport";
import MenuIcon from '@mui/icons-material/Menu';
import { Fab } from "@mui/material";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { useEffect } from "react";

export default function TargetMain({ search, DefaultSearch }: { search: string, DefaultSearch: (value: string) => void; }) {
    const [anchorElMenu, setAnchorElMenu] = React.useState(null);
    const [menuId, setMenuId] = React.useState(GetDefaultMenuId());

    function GetDefaultMenuId() {
        let val = localStorage.getItem("TargetLastMenuId");
        if (val != null) return val;
        return 1;
    }

    useEffect(() => {
        localStorage.setItem("TargetLastMenuId", menuId.toString());
        if(menuId!=3){
            DefaultSearch("");
        }
    }, [menuId]);

    function opMenuOpenClick(e: any) {
        setAnchorElMenu(e.currentTarget);

    }
    return <div style={{ marginLeft: 20 }}>
        <div style={{ position: "fixed", left: "15px", bottom: "15px" }}>
            <Fab color="primary" aria-label="add" onClick={(event) => { opMenuOpenClick(event) }} >
                <MenuIcon></MenuIcon>
            </Fab>
        </div>
        {menuId == 1 && <Dealer search={search}/>}
        {menuId == 2 && <TargetMatrics/>}
        {menuId == 3 && <TargetUsageReport />}
        {menuId == 4 && <TargetFeedReport />}   
        {menuId == 5 && <TargetBroadcastEmailReport />}
        <Menu
            style={{ marginBottom: "100px !important" }}
            id="basic-menu"
            anchorEl={anchorElMenu}
            open={anchorElMenu != null}
            onClose={(event) => { setAnchorElMenu(null) }}          
            MenuListProps={{
                'aria-labelledby': 'basic-button',
            }}
        >
            <MenuItem onClick={(e: any) => { setMenuId(1); setAnchorElMenu(null) }} >Target Dealers</MenuItem>
            <MenuItem onClick={(e: any) => { setMenuId(2); setAnchorElMenu(null) }} >Target Metrics</MenuItem>
            <MenuItem onClick={(e: any) => { setMenuId(3); setAnchorElMenu(null) }} >Target Usage Report</MenuItem>   
            <MenuItem onClick={(e: any) => { setMenuId(4); setAnchorElMenu(null) }} >Target Feed Report</MenuItem> 
            <MenuItem onClick={(e: any) => { setMenuId(5); setAnchorElMenu(null) }} >Target Broadcast Email Report</MenuItem>
        </Menu>
    </div>;
}


